import React from 'react';
import data from '../../legal-content/terms.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const TermsOfServicePage = () => <LegalDocument data={data} currentPage="TermsOfServicePage" />;

export default TermsOfServicePage;
